import { RootReducer } from '../redux/rootReducer'
import React from 'react'
import { useSelector } from 'react-redux'

const SlideContent = () => {
  const { slide } = useSelector((state: RootReducer) => state.slidesReducer)

  const content = `
  <style>
    :host {
      all: initial;
    }
  </style>
  <div style="color: black; background-color: white; font-family: 'Open Sans', sans-serif;">
    ${slide.html}
  </div>
  `

  return (
    <div
      className="w-full h-full bg-[white] font-sans text-white"
      ref={(node) => {
        if (node) {
          if (!node.shadowRoot) {
            const shadowRoot = node.attachShadow({ mode: 'open' })
            shadowRoot.innerHTML = content
          } else {
            node.shadowRoot.innerHTML = content
          }
        }
      }}
    />
  )
}

export default SlideContent
